import { createAsyncAction, createAction } from 'typesafe-actions';

import { AresModel } from '../../api/interfaces';

export const getCompanyInfoAsync = createAsyncAction(
    'ares/GET_COMPANY_INFO_REQUEST',
    'ares/GET_COMPANY_INFO_SUCCESS',
    'ares/GET_COMPANY_INFO_FAILURE'
)<string, AresModel, Error>();
